import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "../util/axiosConfig";

type ExpEntry = {
	level: number;
	expRequired: number;
	cumulativeExp: number;
};

const ExpTableContext = createContext<ExpEntry[]>([]);

export const ExpTableProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [expTable, setExpTable] = useState<ExpEntry[]>([]);

	useEffect(() => {
		const fetchExpTable = async () => {
			try {
				const res = await axios.get("/api/level/expTable");
				setExpTable(res.data);
			} catch (err) {
				console.error("경험치 테이블 불러오기 실패:", err);
			}
		};
		fetchExpTable();
	}, []);

	return (
		<ExpTableContext.Provider value={expTable}>
			{children}
		</ExpTableContext.Provider>
	);
};

export const useExpTable = () => useContext(ExpTableContext);
